export default "__VITE_PUBLIC_ASSET__17f3de43__"